export default __webpack_public_path__ + "static/media/avatar.fd6d82b4.jpg";